import { getLocalizedString } from '../localization/getLocalizedString';
import { format, localizedFormatter } from './localizedFormatter';

/**
 * Gets the localized version of "d dddd".
 * Useful for a calendar week headers.
 */
export function getDayWeekDayFormat() {
    // We're making an explicit choice to ignore d or dd in dateFormat and always use d.
    return format(getLocalizedString('dayWeekDayFormat'), 'd');
}

export default localizedFormatter(getDayWeekDayFormat);
